import { postOrdersMarketIdManagerDice } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

/**
 * Allows to assign project managers randomly to orders in a specific market.
 */
export const useManagerDiceOrderMutation = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((marketId: number) =>
			postOrdersMarketIdManagerDice(marketId),
		),
		onError: (error) => {
			console.error(
				`${t(orderMutationsResource.orderManagerDiceError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(orderMutationsResource.orderManagerDiceSuccess));
			queryClient.invalidateQueries({ queryKey: orderKeys.listAll });
		},
	});
};
